export const useProductSubscriptionStore = defineStore('product-subscription', () => {
  const { baseURL } = useRuntimeConfig().app
  const { $i18n, $storeErrorLog } = useNuxtApp()
  const userStore = useUserStore()
  const accessToken = computed(() => userStore.accessToken)
  const { withAuthRetry } = useWithAuthRetry()

  async function create(product: string) {
    if (!unref(accessToken)) return
    try {
      return await withAuthRetry(() => $fetch('/api/intern/products/subscriptions', {
        method: 'POST',
        headers: { Authorization: `Bearer ${unref(accessToken)}` },
        body: { product },
        baseURL,
      }))
    }
    catch (error: any) {
      $storeErrorLog('stores/product-subscription.ts', `Could not create product subscription for product: ${product}`, $i18n.t('errors.page.unknown.subtitle'), error)
    }
  }

  async function deleteSubscription(product: string) {
    if (!unref(accessToken)) return
    try {
      return await withAuthRetry(() => $fetch('/api/intern/products/subscriptions', {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${unref(accessToken)}` },
        body: { product },
        baseURL,
      }))
    }
    catch (error: any) {
      $storeErrorLog('stores/product-subscription.ts', `Could not delete product subscription for product: ${product}`, $i18n.t('errors.page.unknown.subtitle'), error)
    }
  }

  return {
    create,
    delete: deleteSubscription,
  }
})
